import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[WorkOrderTypes SetFilter] Action',
  ResetFilter: '[WorkOrderTypes ResetFilter] Action',
}

const initialWorkOrderTypesState: IWorkOrderTypesState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IWorkOrderTypesState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-WorkOrderTypes', whitelist: ['filter']},
  (
    state: IWorkOrderTypesState = initialWorkOrderTypesState,
    action: ActionWithPayload<IWorkOrderTypesState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialWorkOrderTypesState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
